import { Card } from '@aimsos/ui';

/**
 * One bordered prototype section: a header row (title + optional right-aligned
 * meta) over its body. The prototype keeps each block in its own card rather
 * than stacking them inside a single "About" card.
 */
function SectionCard({ title, meta, children }) {
  return (
    <Card>
      <Card.Body>
        <div className="mb-2 flex items-center justify-between gap-2">
          <h3 className="text-sm font-semibold text-content">{title}</h3>
          {meta ? <span className="text-xs text-content-faint">{meta}</span> : null}
        </div>
        {children}
      </Card.Body>
    </Card>
  );
}

export default SectionCard;
